import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// pages
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import PageNotFound from './pages/PageNotFound';
import Graphics from './pages/Graphics';
import AIScheduler from './pages/case-studies/AIScheduler';
import TherapEase from './pages/case-studies/TherapEase';
import CampusPost from './pages/case-studies/CampusPost';
import OtherWork from './pages/OtherWork';
// components
import Footer from './components/Footer';
import RedirectExample from './pages/RedirectExample';
import ProjectIndex from './pages/projects/Index';
import ProjectShow from './pages/projects/Show';
import Resume from './pages/Resume';
import { Provider } from "./components/ui/provider"

const App = (() => {
  return(
    <>
    <Provider>
    <Router>
      {/* Navbar removed in favour of the hero navigation in Home */}

      <Routes>
        <Route path={"/"} element={<Home />} />
        <Route path={"/about"} element={<About />} />
        <Route path={"/contact"} element={<Contact />} />
        <Route path={"/graphics"} element={<Graphics />} />
        <Route path={"/other-work"} element={<OtherWork />} />
        <Route path={"/case-studies/ai-scheduler"} element={<AIScheduler />} />
        <Route path={"/case-studies/therapease"} element={<TherapEase />} />
        <Route path={"/case-studies/campuspost"} element={<CampusPost />} />
        <Route path={"*"} element={<PageNotFound />}  />
        <Route path={"/redirect"} element={<RedirectExample />} />

        <Route path={"/projects"} element={<ProjectIndex/>} />
        <Route path={"/projects/:slug"} element={<ProjectShow/>} />
        <Route path={"/resume"} element={<Resume/>} />

      </Routes>
      <Footer />
    </Router>
    </Provider>
    </>
  )
})

export default App;